var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerticalGreenColorLine = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 2,
  height: 40,
  viewBox: "0 0 2 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 0.827881,
  y1: 0.475098,
  x2: 0.827879,
  y2: 39.1802,
  stroke: "#658F38"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerticalGreenColorLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vertical-green-color-line.5cea0673cc57d53bb00c428352f96536.svg";